module.exports = __webpack_public_path__ + "img/file-preview.d1b86349.png";